import { createContext } from "react";
import type { useChatSocket } from "../hooks/useChatSocket";

export type ChatSocketValue = ReturnType<typeof useChatSocket>;

export const ChatSocketContext = createContext<ChatSocketValue | null>(null);
